import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Center } from '../shared/models/center';

@Injectable({
  providedIn: 'root',
})
export class CenterService {

  constructor(private http: HttpClient) { }

  query({ siteId }): Observable<Center[]> {
    return this.http.get<Center[]>(`api/sites/${siteId}/api/v1/centers`);
  }
}
